(function ($) {

'use strict';

	/**
	 * Returns formatted size string including the unit
	 * @param {int} bytes
	 * @param {int} decimals
	 * @returns {String}
	 */
	$.formatBytes = function (bytes, decimals) {
		if (bytes === 0) {
			return '0 KB';
		}
		var k = 1024;
		var dm = decimals || 2;
		var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
		var i = Math.floor(Math.log(bytes) / Math.log(k));

		if (i === 0) {
			// return '1 KB' if the unit is 'Bytes'
			return '1 KB';
		}
		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	};

}(jQuery));